import { useCachedApiCall, type UseCachedApiCallResult } from '@hooks/apiCall';
import { positionsCache } from './positionStore';
import type { Position } from '@api/DepartmentService';

/** Cache-backed positions of a department. */
export const usePositionsEntry = (
    departmentId?: string,
): UseCachedApiCallResult<Position[]> =>
    useCachedApiCall(positionsCache, [departmentId]);
